import React from 'react';
import { Button, Box, Typography, ImageList } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Receipt, Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import SingleImageDialog from './SingleImageDialog';

const ImagesDialog = ({ imageUrl }) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Button
                onClick={handleOpen}
                disabled={imageUrl === null}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500],
                    cursor: imageUrl === null ? 'not-allowed' : 'pointer'
                }}
            >
                <Receipt />
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="deposit-images"
                aria-describedby="modal-deposit-images"
                scroll="paper"
            >
                <DialogTitle id="deposit-images-dialog-title">
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            Images
                        </Typography>
                        <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {imageUrl?.length > 0 && (
                        <ImageList sx={{ width: '100%' }} cols={3} rowHeight={'auto'}>
                            {imageUrl.map((item, index) => (
                                <SingleImageDialog imageSrc={item} key={index} />
                            ))}
                        </ImageList>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ImagesDialog;
